import React, { useState } from "react";
import * as yup from "yup";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import OnlineShopFormContent from "./OnlineShopFormContent";
const onlineShopSchema = yup.object().shape({
  ID: yup.number(),
});
function OnlineShopForm({ history }) {
  const [onlineShop, setOnlineShpp] = useState({});

  return (
    <React.Fragment>
      <PageSubHeader
        title="Account Payable Payment Form"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/online-shop",
            title: "Online Shop List",
            active: false,
          },
          {
            page: "/sales/online-shop-form",
            title: "Online Shop",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/sales/online-shop");
            },
          },
        ]}
      />
      <AppForm
        initialValues={onlineShop}
        validationSchema={onlineShopSchema}
        headSubmitButton
        onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {}}
      >
        <ContentLayout>
          <OnlineShopFormContent />
        </ContentLayout>
      </AppForm>
    </React.Fragment>
  );
}

export default OnlineShopForm;
